var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Refresh_svg__mask-2)",
    transform: "translate(-12 -46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.815 49.806l-2.44 2.442a.438.438 0 00.307.752h1.565A5.253 5.253 0 0121 58.25a5.09 5.09 0 01-1.968-.385c-.314-.131-.673-.035-.91.201a.877.877 0 00.298 1.435c.796.324 1.67.499 2.58.499a6.996 6.996 0 006.996-7h1.565a.433.433 0 00.306-.744l-2.44-2.441a.43.43 0 00-.612-.009zM15.753 53A5.253 5.253 0 0121 47.75c.69 0 1.364.131 1.968.385.314.131.673.035.91-.201a.877.877 0 00-.298-1.435A6.842 6.842 0 0021 46a6.996 6.996 0 00-6.996 7h-1.565a.433.433 0 00-.306.744l2.44 2.441a.433.433 0 00.62 0l2.44-2.441a.437.437 0 00-.315-.744h-1.565z",
    fill: "#596168"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default ForwardRef;